// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host #map {
  width: calc(100% - 24px);
  height: 600px;
  margin: 0 12px 12px;
  background-color: #F2F2F4;
}
@media (max-width: 1024px) {
  :host #map {
    height: 534px;
  }
}
@media (max-width: 900px) {
  :host #map {
    height: 476px;
  }
}
@media (max-width: 768px) {
  :host #map {
    margin: 0 20px 12px;
    width: calc(100% - 40px);
    height: 570px;
  }
}
@media (max-width: 768px) and (min-width: 600px) {
  :host #map {
    height: 450px;
  }
}
:host #map ::ng-deep path {
  mix-blend-mode: multiply;
}
:host #map ::ng-deep .leaflet-marker-shadow {
  display: none;
}
:host #map ::ng-deep .leaflet-marker-icon.marker {
  height: 60px !important;
  width: 60px !important;
  background-color: #FFF;
  color: #1A1E29;
  box-shadow: 0 0 0 12px rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.mini {
  height: 28px !important;
  width: 28px !important;
  box-shadow: 0 0 0 6px rgba(255, 255, 255, 0.15);
}
@media (max-width: 768px) {
  :host #map ::ng-deep .leaflet-marker-icon.marker {
    height: 28px !important;
    width: 28px !important;
    box-shadow: 0 0 0 6px rgba(255, 255, 255, 0.15);
  }
}
:host #map ::ng-deep .leaflet-marker-icon.marker.stat {
  margin: -30px 0 0 -30px !important;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.stat .points {
  font-weight: 400;
  font-family: "RM Neue";
  font-size: 20px;
  line-height: 20px;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.stat .accuracy {
  margin-top: 6px;
  font-size: 10px;
  line-height: 10px;
  color: #4B505F;
  background-color: #E4E5E8;
  padding: 2px 4px;
  border-radius: 6px;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.stat.mini {
  margin: -14px 0 0 -14px !important;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.stat.mini .points {
  font-size: 16px;
  line-height: 16px;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.stat.mini .accuracy {
  display: none;
}
@media (max-width: 768px) {
  :host #map ::ng-deep .leaflet-marker-icon.marker.stat {
    margin: -14px 0 0 -14px !important;
  }
  :host #map ::ng-deep .leaflet-marker-icon.marker.stat .points {
    font-size: 16px;
    line-height: 16px;
  }
  :host #map ::ng-deep .leaflet-marker-icon.marker.stat .accuracy {
    display: none;
  }
}
:host #map ::ng-deep .leaflet-marker-icon.marker.leader {
  box-shadow: 0 0 0 12px rgba(228, 229, 232, 0.5);
  margin: -30px 0 0 -30px !important;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.leader .photo {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  border: 1px solid #1A1E29;
  background-size: contain;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.leader .points {
  font-weight: 400;
  font-family: "RM Neue";
  font-size: 20px;
  line-height: 20px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateX(100%) translateX(20px) translateY(-50%);
}
:host #map ::ng-deep .leaflet-marker-icon.marker.leader .initials {
  font-weight: 300;
  font-family: "RM Neue";
  font-size: 24px;
  line-height: 24px;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.leader.mini {
  box-shadow: 0 0 0 6px rgba(228, 229, 232, 0.5);
  margin: -14px 0 0 -14px !important;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.leader.mini .points {
  font-size: 16px;
  line-height: 16px;
  transform: translateX(100%) translateX(10px) translateY(-50%);
}
:host #map ::ng-deep .leaflet-marker-icon.marker.leader.mini .initials {
  font-size: 16px;
  line-height: 16px;
}
@media (max-width: 768px) {
  :host #map ::ng-deep .leaflet-marker-icon.marker.leader {
    box-shadow: 0 0 0 6px rgba(228, 229, 232, 0.5);
    margin: -14px 0 0 -14px !important;
  }
  :host #map ::ng-deep .leaflet-marker-icon.marker.leader .points {
    font-size: 16px;
    line-height: 16px;
    transform: translateX(100%) translateX(10px) translateY(-50%);
  }
  :host #map ::ng-deep .leaflet-marker-icon.marker.leader .initials {
    font-size: 16px;
    line-height: 16px;
  }
}
:host #map ::ng-deep .leaflet-marker-icon.marker.leader.leftSide .points {
  left: 0;
  right: auto;
  transform: translateX(-100%) translateX(-20px) translateY(-50%);
}
:host #map ::ng-deep .leaflet-marker-icon.marker.leader.leftSide.mini .points {
  transform: translateX(-100%) translateX(-10px) translateY(-50%);
}
@media (max-width: 768px) {
  :host #map ::ng-deep .leaflet-marker-icon.marker.leader.leftSide .points {
    transform: translateX(-100%) translateX(-10px) translateY(-50%);
  }
}
:host #map ::ng-deep .leaflet-marker-icon.marker.acc0 {
  background-color: #FFFFFF;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.acc1 {
  background-color: #FFFFCC;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.acc2 {
  background-color: #A1DAB4;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.acc3 {
  background-color: #41B6C4;
  color: #FFF;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.acc4 {
  background-color: #2C7FB8;
  color: #FFF;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.acc5 {
  background-color: #253494;
  color: #FFF;
}
:host #map ::ng-deep .leaflet-marker-icon.marker.acc6 {
  background-color: #253494;
  color: #FFF;
}
:host #map ::ng-deep .leaflet-popup .leaflet-popup-content-wrapper {
  background-color: #1A1E29;
  color: #FFF;
  border-radius: 2px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
}
:host #map ::ng-deep .leaflet-popup .leaflet-popup-content-wrapper .leaflet-popup-content {
  margin: 0;
}
:host #map ::ng-deep .leaflet-popup .leaflet-popup-tip {
  background-color: #292D3A;
}
:host #map ::ng-deep .ads {
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.5);
  z-index: 200;
  position: relative;
  overflow: hidden;
}
:host #map ::ng-deep .ads > div {
  height: 100%;
  width: 100%;
}
:host #map ::ng-deep .ads > div iframe {
  height: 100%;
  width: 100%;
}
:host .popup {
  position: fixed;
  display: block;
  z-index: 500;
  opacity: 0;
  visibility: hidden;
  transform: translate(-50%, -100%);
  transition: visibility 0.1s linear 0.1s, opacity 0.1s ease-out 0.1s;
}
:host .popup.shown {
  opacity: 1;
  visibility: visible;
  transition: visibility 0.1s linear, opacity 0.1s ease-out;
}
:host .mapZoomControlWrapper {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  z-index: 800;
}
@media (max-width: 768px) {
  :host .mapZoomControlWrapper {
    display: none;
  }
}
:host .mapZoomControlWrapper .group {
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  overflow: hidden;
}
:host .mapZoomControlWrapper .group > * + * {
  border-top: 1px solid #E4E5E8;
}
:host .mapZoomControlWrapper .group + .group {
  margin-top: 12px;
}
:host .mapZoomControlWrapper .button {
  height: 32px;
  width: 32px;
  padding: 6px;
}
:host .mapZoomControlWrapper .button img {
  opacity: 0.5;
}
:host .mapZoomControlWrapper .button:hover img {
  opacity: 1;
}

@-moz-document url-prefix() {
  .leaflet-marker-icon.marker.stat.mini .points {
    margin-bottom: 1px;
  }
  @media (max-width: 768px) {
    .leaflet-marker-icon.marker.stat .points {
      margin-bottom: 1px;
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/app/common/map-base/map-base.component.scss","webpack://./src/theme.scss"],"names":[],"mappings":"AAGE;EACE,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBCUO;ADZX;AAGI;EALF;IAMI,aAAA;EAAJ;AACF;AACI;EARF;IASI,aAAA;EAEJ;AACF;AADI;EAXF;IAYI,mBAAA;IACA,wBAAA;IACA,aAAA;EAIJ;AACF;AAJM;EAfJ;IAgBM,aAAA;EAON;AACF;AAHM;EACE,wBAAA;AAKR;AAFM;EACE,aAAA;AAIR;AAAQ;EACE,uBAAA;EACA,sBAAA;EACA,sBClBG;EDmBH,cC9BE;ED+BF,gDAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAEV;AAAU;EACE,uBAAA;EACA,sBAAA;EACA,+CAAA;AAEZ;AAAU;EAjBF;IAkBI,uBAAA;IACA,sBAAA;IACA,+CAAA;EAGV;AACF;AADU;EACE,kCAAA;AAGZ;AADY;ECAR,gBAAA;EAUA,sBAAA;EDRU,eAAA;EACA,iBAAA;AAId;AADY;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cC3DH;ED4DG,yBCtDH;EDuDG,gBAAA;EACA,kBAAA;AAGd;AAAY;EACE,kCAAA;AAEd;AAAc;EACE,eAAA;EACA,iBAAA;AAEhB;AACc;EACE,aAAA;AAChB;AAEY;EA/BF;IAgCI,kCAAA;EACZ;EACY;IACE,eAAA;IACA,iBAAA;EACd;EAEY;IACE,aAAA;EAAd;AACF;AAIU;EACE,+CAAA;EACA,kCAAA;AAFZ;AAIY;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;AAFd;AAKY;ECzDR,gBAAA;EAUA,sBAAA;EDiDU,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,6DAAA;AAFd;AAKY;ECrER,gBAAA;EAYA,sBAAA;ED2DU,eAAA;EACA,iBAAA;AAFd;AAKY;EACE,8CAAA;EACA,kCAAA;AAHd;AAKc;EACE,eAAA;EACA,iBAAA;EACA,6DAAA;AAHhB;AAMc;EACE,eAAA;EACA,iBAAA;AAJhB;AAOY;EA9CF;IA+CI,8CAAA;IACA,kCAAA;EAJZ;EAMY;IACE,eAAA;IACA,iBAAA;IACA,6DAAA;EAJd;EAOY;IACE,eAAA;IACA,iBAAA;EALd;AACF;AASc;EACE,OAAA;EACA,WAAA;EACA,+DAAA;AAPhB;AAUc;EACE,+DAAA;AARhB;AAUc;EACE;IACE,+DAAA;EARhB;AACF;AAsBY;EACE,yBAVkB;AAVhC;AAmBY;EACE,yBAVkB;AAPhC;AAgBY;EACE,yBAVkB;AAJhC;AAaY;EACE,yBAVkB;EAYhB,WC/KH;ADmKb;AASY;EACE,yBAVkB;EAYhB,WC/KH;ADuKb;AAKY;EACE,yBAVkB;EAYhB,WC/KH;AD2Kb;AACY;EACE,yBAVkB;EAYhB,WC/KH;AD+Kb;AAQQ;EACE,yBCnME;EDoMF,WCzLG;ED0LH,kBAAA;EACA,wCAAA;AANV;AAQU;EACE,SAAA;AANZ;AAUQ;EACE,yBC7MC;ADqMX;AAYM;EACE,kBAAA;EACA,0CAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAVR;AAYQ;EACE,YAAA;EACA,WAAA;AAVV;AAYU;EACE,YAAA;EACA,WAAA;AAVZ;AAsBE;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,iCAAA;EACA,mEAAA;AApBJ;AAuBI;EACE,UAAA;EACA,mBAAA;EACA,yDAAA;AArBN;AA0BE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,YAAA;AAxBJ;AAyBI;EANF;IAOI,aAAA;EAtBJ;AACF;AAwBI;EACE,wCAAA;EACA,kBAAA;EACA,gBAAA;AAtBN;AAwBM;EACE,6BAAA;AAtBR;AAyBM;EACE,gBAAA;AAvBR;AA2BI;EACE,YAAA;EACA,WAAA;EACA,YAAA;AAzBN;AA2BM;EACE,YAAA;AAzBR;AA4BM;EACE,UAAA;AA1BR;;AA+BA;EACE;IACE,kBAAA;EA5BF;EA8BA;IACE;MACE,kBAAA;IA5BF;EACF;AACF","sourcesContent":["@import 'theme';\n\n:host {\n  #map {\n    width: calc(100% - 24px);\n    height: 600px;\n    margin: 0 12px 12px;\n    background-color: $colorN05;\n    @media (max-width: 1024px) {\n      height: 534px;\n    }\n    @media (max-width: 900px) {\n      height: 476px;\n    }\n    @media (max-width: $mobileBreakpoint) {\n      margin: 0 20px 12px;\n      width: calc(100% - 40px);\n      height: 570px;\n      @media (min-width: 600px) {\n        height: 450px;\n      }\n    }\n\n    & ::ng-deep {\n      path {\n        mix-blend-mode: multiply;\n      }\n\n      .leaflet-marker-shadow {\n        display: none;\n      }\n\n      .leaflet-marker-icon {\n        &.marker {\n          height: 60px !important;\n          width: 60px !important;\n          background-color: $colorWhite;\n          color: $colorN100;\n          box-shadow: 0 0 0 12px transparentize($colorWhite, .85);\n          border-radius: 50%;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          justify-content: center;\n\n          &.mini {\n            height: 28px !important;\n            width: 28px !important;\n            box-shadow: 0 0 0 6px transparentize($colorWhite, .85);\n          }\n          @media (max-width: $mobileBreakpoint) {\n            height: 28px !important;\n            width: 28px !important;\n            box-shadow: 0 0 0 6px transparentize($colorWhite, .85);\n          }\n\n          &.stat {\n            margin: -30px 0 0 -30px !important;\n\n            .points {\n              @include font(normal, condensed);\n              font-size: 20px;\n              line-height: 20px;\n            }\n\n            .accuracy {\n              margin-top: 6px;\n              font-size: 10px;\n              line-height: 10px;\n              color: $colorN70;\n              background-color: $colorN10;\n              padding: 2px 4px;\n              border-radius: 6px;\n            }\n\n            &.mini {\n              margin: -14px 0 0 -14px !important;\n\n              .points {\n                font-size: 16px;\n                line-height: 16px;\n              }\n\n              .accuracy {\n                display: none;\n              }\n            }\n            @media (max-width: $mobileBreakpoint) {\n              margin: -14px 0 0 -14px !important;\n\n              .points {\n                font-size: 16px;\n                line-height: 16px;\n              }\n\n              .accuracy {\n                display: none;\n              }\n            }\n          }\n\n          &.leader {\n            box-shadow: 0 0 0 12px transparentize($colorN10, .5);\n            margin: -30px 0 0 -30px !important;\n\n            .photo {\n              position: absolute;\n              top: 0;\n              left: 0;\n              height: 100%;\n              width: 100%;\n              border-radius: 50%;\n              border: 1px solid $colorN100;\n              background-size: contain;\n            }\n\n            .points {\n              @include font(normal, condensed);\n              font-size: 20px;\n              line-height: 20px;\n              position: absolute;\n              right: 0;\n              top: 50%;\n              transform: translateX(100%) translateX(20px) translateY(-50%);\n            }\n\n            .initials {\n              @include font(light, condensed);\n              font-size: 24px;\n              line-height: 24px;\n            }\n\n            &.mini {\n              box-shadow: 0 0 0 6px transparentize($colorN10, .5);\n              margin: -14px 0 0 -14px !important;\n\n              .points {\n                font-size: 16px;\n                line-height: 16px;\n                transform: translateX(100%) translateX(10px) translateY(-50%);\n              }\n\n              .initials {\n                font-size: 16px;\n                line-height: 16px;\n              }\n            }\n            @media (max-width: $mobileBreakpoint) {\n              box-shadow: 0 0 0 6px transparentize($colorN10, .5);\n              margin: -14px 0 0 -14px !important;\n\n              .points {\n                font-size: 16px;\n                line-height: 16px;\n                transform: translateX(100%) translateX(10px) translateY(-50%);\n              }\n\n              .initials {\n                font-size: 16px;\n                line-height: 16px;\n              }\n            }\n\n            &.leftSide {\n              .points {\n                left: 0;\n                right: auto;\n                transform: translateX(-100%) translateX(-20px) translateY(-50%);\n              }\n\n              &.mini .points {\n                transform: translateX(-100%) translateX(-10px) translateY(-50%);\n              }\n              @media (max-width: $mobileBreakpoint) {\n                .points {\n                  transform: translateX(-100%) translateX(-10px) translateY(-50%);\n                }\n              }\n            }\n          }\n\n          @each $idx, $color in (\n            0: $gridRampComp1,\n            1: $gridRampComp2,\n            2: $gridRampComp3,\n            3: $gridRampComp4,\n            4: $gridRampComp5,\n            5: $gridRampComp6,\n            6: $gridRampComp6\n          ) {\n            &.acc#{$idx} {\n              background-color: $color;\n              @if nth($idx, 1) > 2 {\n                color: $colorWhite;\n              }\n            }\n          }\n        }\n      }\n\n      .leaflet-popup {\n        .leaflet-popup-content-wrapper {\n          background-color: $colorN100;\n          color: $colorWhite;\n          border-radius: 2px;\n          box-shadow: 0 0 8px 0 transparentize($colorBlack, .9);\n\n          .leaflet-popup-content {\n            margin: 0;\n          }\n        }\n\n        .leaflet-popup-tip {\n          background-color: $colorN90;\n        }\n      }\n\n      .ads {\n        border-radius: 50%;\n        border: 2px solid transparentize($colorWhite, .5);\n        z-index: 200;\n        position: relative;\n        overflow: hidden;\n\n        & > div {\n          height: 100%;\n          width: 100%;\n\n          iframe {\n            height: 100%;\n            width: 100%;\n\n            // & ::ng-deep #google_image_div {\n            //   height: 100%;\n            //   width: 100%;\n            // }\n          }\n        }\n      }\n    }\n  }\n\n  .popup {\n    position: fixed;\n    display: block;\n    z-index: 500;\n    opacity: 0;\n    visibility: hidden;\n    transform: translate(-50%, -100%);\n    transition: visibility 0.1s $animationFuncAlt $animationTimeBlink,\n                opacity $animationTimeBlink $animationFuncDefault 0.1s;\n\n    &.shown {\n      opacity: 1;\n      visibility: visible;\n      transition: visibility 0.1s $animationFuncAlt,\n                  opacity $animationTimeBlink $animationFuncDefault;\n    }\n  }\n\n  .mapZoomControlWrapper {\n    position: absolute;\n    top: 50%;\n    left: 12px;\n    transform: translateY(-50%);\n    z-index: 800;\n    @media(max-width: $mobileBreakpoint) {\n      display: none;\n    }\n\n    .group {\n      box-shadow: 0 0 8px 0 transparentize($colorBlack, .9);\n      border-radius: 2px;\n      overflow: hidden;\n\n      & > * + * {\n        border-top: 1px solid $colorN10;\n      }\n\n      & + .group {\n        margin-top: 12px;\n      }\n    }\n\n    .button {\n      height: 32px;\n      width: 32px;\n      padding: 6px;\n\n      img {\n        opacity: .5;\n      }\n\n      &:hover img {\n        opacity: 1;\n      }\n    }\n  }\n}\n@-moz-document url-prefix() {\n  .leaflet-marker-icon.marker.stat.mini .points {\n    margin-bottom: 1px;\n  }\n  @media (max-width: $mobileBreakpoint) {\n    .leaflet-marker-icon.marker.stat .points {\n      margin-bottom: 1px;\n    }\n  }\n}\n","$colorPrimary: #3E31FA;\n$colorPrimaryBg: #EEF2FD;\n$colorAccent: #1785FB;\n$colorSecondary: #C8B17B;\n\n$colorAdsBG: #0D0D0D;\n$colorBlack: #000;\n$colorN100: #1A1E29;\n$colorN90: #292D3A;\n$colorN80: #383D4C;\n$colorN70: #4B505F;\n$colorN60: #626775;\n$colorN50: #787D8B;\n$colorN40: #9397A2;\n$colorN30: #AEB1B9;\n$colorN20: #C9CBD1;\n$colorN10: #E4E5E8;\n$colorN05: #F2F2F4;\n$colorWhite: #FFF;\n\n$colorBestPlayer: #F2B701;\n$colorDisabled: $colorN30;\n\n$gridRampComp1: #FFFFFF;\n$gridRampComp2: #FFFFCC;\n$gridRampComp3: #A1DAB4;\n$gridRampComp4: #41B6C4;\n$gridRampComp5: #2C7FB8;\n$gridRampComp6: #253494;\n\n$colorGood: #A2D98C;\n$colorBad: #E73F74;\n$colorLive: #3D923D;\n$colorLiveTooltip: #A2D98C;\n\n$colorNotFound: #DC0032;\n$colorBackgroundTooltip: #0F2145;\n\n$colorGreyPlacehold: #8C95A6;\n$colorGreyTitle: #0F2145;\n$colorGreyLabel: #5E6A83;\n$colorGreyDark: #29395A;\n$colorGreyOffWhite: #FBFDFF;\n$colorGreyOffBlack: #14142B;\n$animationTimeSlow: 2s;\n$animationTimeNormal: 1s;\n$animationTimeFast: .5s;\n$animationTimeBlink: .1s;\n$animationFuncDefault: ease-out;\n$animationFuncAlt: linear;\n\n$mobileBreakpoint: 768px;\n\n@mixin font($weight: normal, $condensed: false) {\n  @if $weight == extra-light {\n    font-weight: 200;\n  } @else if $weight == light {\n    font-weight: 300;\n  } @else if $weight == normal {\n    font-weight: 400;\n  } @else if $weight == medium {\n    font-weight: 500;\n  } @else if $weight == bold {\n    font-weight: 700;\n  } @else if $weight == black {\n    font-weight: 900;\n  }\n\n  @if $condensed == condensed {\n    font-family: 'RM Neue';\n  } @else {\n    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  }\n}\n\n@mixin pseudoElemIcon($file, $height, $width) {\n  content: '';\n  display: inline-block;\n  height: $height;\n  width: $width;\n  background-image: url($file);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n@mixin noselect() {\n  -webkit-touch-callout: none;\n    -webkit-user-select: none;\n     -khtml-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n@mixin button($file: null) {\n  border: none;\n  cursor: pointer;\n  display: flex;\n  padding: 12px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: linear-gradient(8deg, #3E31FA 19.1%, #8760F6 94.27%);\n  color: $colorGreyOffWhite;\n  @include font(medium);\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n\n  @if $file != null {\n    &::before {\n      @include pseudoElemIcon($file, 16px, 16px);\n    }\n  }\n}\n\n@mixin headingH3() {\n  @include font(bold);\n  font-size: 32px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyOffBlack;\n  text-align: center;\n}\n@mixin headingH5() {\n  @include font(normal);\n  font-size: 24px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyDark;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
